import React from 'react';
import "../../../components/calcInputs/calcInputs.css"

const JudgmentsInputs = (props) => {

    return ( 
        <>
            <div className="inputsBox">
                <form id="calcForm" noValidate>
                    <div className="fullRow">
                        <div className="mainRow2">
                            <div className="row">
                                <div className="rCol1">
                                    <label htmlFor="actualJudgmentDate">
                                    Data <span className="requiredStar">*</span>
                                    <input type="date" id="actualJudgmentDate" name="actualJudgmentDate" value={props.actualJudgmentDate} onChange={props.handleActualJudgmentDateChange}/>
                                    </label>
                                </div>
                                <div className="rCol2">
                                    <label htmlFor="actualJudgmentSignature">
                                    Sygnatura <span className="requiredStar">*</span>
                                    <input type="text" id="actualJudgmentSignature" name="actualJudgmentSignature" value={props.actualJudgmentSignature} onChange={props.handleActualJudgmentSignatureChange}/>
                                    </label>
                                </div>
                                <div className="rCol3">
                                    <label htmlFor="actualJudgmentCourt">
                                    Sąd <span className="requiredStar">*</span>
                                    <input type="text" id="actualJudgmentCourt" name="actualJudgmentCourt" value={props.actualJudgmentCourt} onChange={props.handleActualJudgmentCourtChange}/>
                                    </label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="rCol1_5">
                                    <label htmlFor="actualJudgmentBank">Wybierz bank <span className="requiredStar">*</span></label>
                                    <select name="actualJudgmentBank" id="actualJudgmentBank" onChange={props.handleActualJudgmentBankChange} value={props.actualJudgmentBank}>
                                        <option key={'a'} value='Wybierz...'>Wybierz bank</option>
                                        {props.banksList.map((bank) => (
                                            <option key={bank.id} value={bank.name}>{bank.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="rCol2_5">
                                <label htmlFor="actualJudgmentNote">
                                    Notatka <span className="requiredStar">*</span>
                                    <input type="text" id="actualJudgmentNote" name="actualJudgmentNote" value={props.actualJudgmentNote} onChange={props.handleActualJudgmentNoteChange}/>
                                    </label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="rCol1_4">
                                <button className="buttonSubForm" onClick={props.handleAddJudgment}>DODAJ</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            
        </>
     );
}
 
export default JudgmentsInputs;